<template src="./index.pug" lang="pug" />

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import request from "@/utils/request";

export default {
  name: 'ImportProducts',
  data() {
    return {
      file: null,
      faqDialogOpen: false,
      establishmentAddresses: [],
      target: {
        brandId: null,
        establishmentId: null,
        establishmentAddressId: null
      }
    };
  },
  computed: {
    ...mapGetters({
      canUploadFile: 'productImport/canUploadFile',
      user: 'user',
      userBrandId: 'userBrandId',
      userEstablishmentId: 'userEstablishmentId',
      userEstablishmentAddressId: 'userEstablishmentAddressId',
    }),
    ...mapState({
      uploadInProgress: s => s.productImport.uploadInProgress,
      importInProgress: s => s.productImport.importInProgress,
      validationResults: s => s.productImport.validationResults,
      savedTarget: s => s.productImport.target,

      brands: state => state.data.brands,
      establishments: state => state.data.establishments
    })
  },
  watch: {
    file() {
      this.$store.commit('productImport/SET_FILE', this.file);
    },
    'target.brandId'(currentValue, prevValue) {
      if (prevValue && currentValue !== prevValue) {
        this.target.establishmentId = null;
      }
    },
    async 'target.establishmentId'(currentValue, prevValue) {
      if (currentValue) {
        if (prevValue && currentValue !== prevValue) {
          this.target.establishmentAddressId = null;
        }

        await request({ method: 'get', url: `/delivery/establishment/${currentValue}/addresses` })
            .then(res => {
              if (res.data) {
                this.establishmentAddresses = this.userEstablishmentAddressId ? [res.data.find(i => i.id === this.userEstablishmentAddressId)] : res.data;

                if (this.userEstablishmentAddressId || (!this.target.establishmentAddressId && this.establishmentAddresses.length === 1)) {
                  this.target.establishmentAddressId = this.establishmentAddresses[0].id;
                }
              }
            }).catch(error => {
              if(error.response && error.response.data && error.response.data.error) {
                this.$store.dispatch('alert/addMessage', {
                  message: error.response.data.error
                }, { root: true });
              }
            });
      } else {
        this.establishmentAddresses = [];
        this.target.establishmentAddressId = null;
      }
    },
    target: {
      handler() {
        this.$store.commit('productImport/UPDATE_TARGET', this.target);
      },
      deep: true
    }
  },
  async created() {
    await this.getBrands();
    await this.getEstablishments();

    if (!this.savedTarget.brandId && !this.savedTarget.establishmentId && !this.savedTarget.establishmentAddressId) {
      if (this.user.brandId) {
        this.target.brandId = this.user.brandId;
      }
      if (this.user.establishmentId) {
        this.target.establishmentId = this.user.establishmentId;
      }
      if (this.user.establishmentAddressId) {
        this.target.establishmentAddressId = this.user.establishmentAddressId;
      }

      this.$store.commit('productImport/UPDATE_TARGET', this.target);
    } else {
      this.target = this.savedTarget;
    }
  },
  methods: {
    ...mapActions({
      getBrands: 'data/getBrands',
      getEstablishments: 'data/getEstablishments'
    }),

    async validateFile() {
      if (!this.canUploadFile && !this.uploadInProgress) {
        return;
      }

      await this.$store.dispatch('productImport/uploadAndValidate');
    },
    async runImport() {
      await this.$store.dispatch('productImport/confirmImport');

      this.file = null;

      this.$store.dispatch('alert/addMessage', {
        type: 'success',
        message: 'success'
      });
    }
  }
};
</script>
